const AppStrings = {
    title: "TOWG",
    website: "towg.ng",
    description: "The ultimate marketplace that connects buyers and sellers directly",
    longDescription: "Buyers can browse a wide range of products, connect with sellers in real time through our integrated chat feature, and make informed purchase decisions with ease.",
    internalServerError: 'Internal server error',
    nairaSymbol: "₦"
}
export default AppStrings